import { TableCell } from "../../ui/Table/Table";

export default function OfferPreviewRow({ offer, i }) {
    const {
        display_line,
        cc,
        language,
        model,
        price,
        cr,
        funnels,
        sources,
    } = offer;

    return (
        <tr>
            <TableCell>
                {i || 0}
            </TableCell>
            <TableCell>
                {cc || '-'}
            </TableCell>
            <TableCell>
                {language || '-'}
            </TableCell>
            <TableCell>
                {model || '-'}
            </TableCell>
            <TableCell>
                {price || '-'}
            </TableCell>
            <TableCell>
                {cr || '-'}
            </TableCell>
            <TableCell>
                {funnels?.join(', ') || '-'}
            </TableCell>
            <TableCell>
                {sources?.join(', ') || '-'}
            </TableCell>
            <TableCell>
                {display_line || '-'}
            </TableCell>
        </tr>
    )
}
